import React, { useState, useEffect } from "react";

import { Checkbox } from "@atlaskit/checkbox";
import { HelperMessage } from "@atlaskit/form";

const RCheckBox = ({ title, checkboxValueLabel, value, id, helperText, width, isDisabled, onChange, onBlur, size, isChecked }) => {
  
  return (
    <>
      <label htmlFor={id}>{title}</label>
      <Checkbox
        className="ihub-ext-chekbox-field"
        name={id}
        value={value}
        isDisabled={isDisabled}
        width={width}
        onChange={onChange}
        onBlur={onBlur}
        label={`${checkboxValueLabel}`}
        size={size}
        isChecked={isChecked}
      />
      <HelperMessage>{helperText}</HelperMessage>
    </>
  );
};
export default RCheckBox;
